//TODO: enter the PIN code to find the shop respective to that PIN
//if PIN is not avaibale then default PIN

//TODO:fetch the list of shop from firebse shoplist node
//pass the selected shop to the item entry component

import React from 'react';
import {db} from '../firebase'
import pinList from "../constants/GlobalVar";
import * as routes from "../constants/routes";
import { Link } from "react-router-dom";
import LoadingScreen from './LoadingScreen'
import {Card, CardText, CardTitle} from 'reactstrap';


class ShopList extends React.Component{
    
    constructor(props){
        super(props);
        // console.log('shop list page');
        // console.log("mmmmmmmmmm"+db.doGetShopList())//https://jharkart-3f408.firebaseio.com/groceryShops
        this.state= {
            loading: true,
        }
    }   

    componentDidMount(){
        console.log("conponent did mount")
        db.doGetShopList().once('value', (snapshot) => {
            pinList.pin = (snapshot.val()); //Object.keys
            // console.log(Object.values(snapshot.val()));
            this.setState({
                loading: false,
            })
        })
        

 }


 //as of now this function is not loading the shop names respective to the PIN code
 // and now it is loading directly the ordering the item page
loadShop= (pinCode)=>{
    console.log("aaaaaaaa");
    this.props.history.push('/ItemEntry')
    // return <Link to={routes.ITEM_ENTRY} />
}

    render(){
        console.log("render function......")
        // var arr = this.getPinList()
        console.log(pinList.pin)
        return(

            this.state.loading ? 
        
            <LoadingScreen/>
        :
        <div>
        {
            //removed Object.keys from below
                    (pinList.pin).map((n,index) =>{
                        return(
                            <Card style={{widht:'100%', height:'50px'}}onClick= {(pinCode) => {
                                pinList.selectedPin=n;
                                this.loadShop();
                            }}>
                                {/* {n[0]}<br/> */}
                                {n}
                            </Card>
                        )
                    })
        }
        </div>
        )
                
        
        
    }
}

export default ShopList;